import axios from 'axios'
import {toData} from "./util";

export function searchUsers(query, subsidiaryId): Promise {
  return axios.get(`/api/users/search?query=${query}&subsidiaryId=${subsidiaryId}`).then(toData)
}

export function getUserLicensesDashboard(query, subsidiaryId): Promise {
  return axios.get(`/api/users/userlicenses/${query}?subsidiaryId=${subsidiaryId}`).then(toData)
}

export function switchLicensesUserId(oldUserId, newUserId, subsidiaryId): Promise {
  return axios.post(`/api/users/switchUsersId?oldUserId=${oldUserId}&newUserId=${newUserId}`).then(toData)
}

export function updateUserFederatedIdentityId(body, subsidiaryId): Promise {
  return axios
      .post(`/api/users/dashboard/updateUserFederatedIdentity`, body)
      .then((response) => {
        if (response.status !== 200) {
          const data = response.data
          const reason =
              (data && data.detail) ||
              `Request failed with status code ${response.status}`

          return Promise.reject({status: response.status, reason, data})
        }

        return {status: response.status, ...response.data}
      })
      .catch((error) => {

        const status = error && error.response ? error.response.status : undefined
        const data = error && error.response ? error.response.data : undefined

        const reason =
            (data && data.detail) ||
            (error && error.message) ||
            'Request to BL/BA failed'

        return Promise.reject({status, reason, data})
      })
}

export function getUser(id, subsidiaryId): Promise {
  return axios.get(`/api/users/${id}?subsidiaryId=${subsidiaryId}`).then(toData)
}

export function searchUserInfoFromProductEAN(query, subsidiaryId): Promise {
  return axios.get(`/api/users/dashboard/getUserInfoByProductEan?query=${query}&subsidiaryId=${subsidiaryId}`).then(toData)
}

export function searchUserInfoFromQuery(query, subsidiaryId): Promise {
  return axios.get(`/api/users/dashboard/userSearch?query=${query}&subsidiaryId=${subsidiaryId}`).then(toData)
}
